module.exports = __webpack_public_path__ + "img/img_bg@3x.7eb977d2.png";